import React from "react";
import { Route } from "react-router-dom";
import { withAuth } from "../core/helpers/withAuth";
import { withSuspense } from "../core/helpers/withSuspense";
import { DashboardRouteUtil } from "../core/routes/dashboard.route";

const SellerBalanceModule = React.lazy(() => import("../pages/dashboard/seller-balance"));

export const SellerBalance: JSX.Element[] = [
  <Route
    exact
    key="seller-balance-module"
    path={DashboardRouteUtil.getSellerBalancePath()}
    component={() => withAuth(withSuspense(SellerBalanceModule))}
  />,

  <Route
    exact
    key="seller-balance-branches-module"
    path={DashboardRouteUtil.getSellerBalanceBranchesPath()}
    component={() => withAuth(withSuspense(SellerBalanceModule))}
  />,
];
